<div *ngIf='(tabsWithActivated$ | async) as tabs' class="tabs" [style.color]="obecSettings.primaryColor" [style.font-family]="obecSettings.title_font" [paddingDefinition]="settings.outerMargin">
  <ng-container *ngFor="let tab of tabs">
    <a [style.background]='tab.active ? obecSettings.primary_color : ""' [style.fontWeight]='tab.active ? "bold" : ""' [style.color]='tab.active ? "white" : obecSettings.primary_color' class="tab" [routerLink]="tab.url">{{tab.nazev}}</a>
  </ng-container>
</div>
